"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Share1: ['share-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25,8.25h1.5a1.5,1.5,0,0,1,1.5,1.5v12a1.5,1.5,0,0,1-1.5,1.5H5.25a1.5,1.5,0,0,1-1.5-1.5v-12a1.5,1.5,0,0,1,1.5-1.5h1.5', 'M12 0.75L12 11.25', 'M8.25 4.5L12 0.75 15.75 4.5']],
  Share3: ['share-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.75,15.75v6a1.5,1.5,0,0,1-1.5,1.5h-12a1.5,1.5,0,0,1-1.5-1.5v-12a1.5,1.5,0,0,1,1.5-1.5H3', 'M15.75,12.75v-3h-4.5a1.5,1.5,0,0,0-1.5,1.5v3s-3-1.5-3-4.5v-3a3,3,0,0,1,3-3h6v-3l7.5,6Z']],
  Share2: ['share-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,5.25H13.5a3,3,0,0,0-3,3V12', 'M17.25 9.75L21.75 5.25 17.25 0.75', 'M18.75,14.25v7.5a1.5,1.5,0,0,1-1.5,1.5H3.75a1.5,1.5,0,0,1-1.5-1.5v-12a1.5,1.5,0,0,1,1.5-1.5H6']],
  UserSignal1: ['user-signal-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.000 12.000 A3.000 3.000 0 1 0 15.000 12.000 A3.000 3.000 0 1 0 9.000 12.000 Z', 'M7.5,22.5a4.5,4.5,0,0,1,9,0Z', 'M7.227,16.773a6.75,6.75,0,1,1,9.546,0', 'M4.575,19.425a10.5,10.5,0,1,1,14.85,0']],
  Megaphone: ['megaphone', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.75,15.25H4.5a3.75,3.75,0,0,1,0-7.5H6.75Z', 'M6.75,15.25a22.3,22.3,0,0,1,12.366,3.744l1.134.756V3.25l-1.134.756A22.3,22.3,0,0,1,6.75,7.75Z', 'M23.25 10L23.25 13', 'M6.75,15.25A7.239,7.239,0,0,0,9,20.5']],
  Megaphone1: ['megaphone-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 9L0.75 15', 'M23.25 1.5L23.25 22.5', 'M0.75 10.5L23.25 3', 'M0.75 13.5L23.25 21', 'M5.126,14.959V15A6.71,6.71,0,0,0,17.1,18.949']],
  Satellite: ['satellite', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.828,14.357A8.25,8.25,0,0,1,9.161,2.689Z', 'M21.359,5.341a2.25,2.25,0,1,1,0-3.182A2.249,2.249,0,0,1,21.359,5.341Z', 'M18.177 5.341L14.995 8.523', 'M3.25,22.522,7.493,18.28a1.5,1.5,0,0,1,2.121,0l4.243,4.242']],
  SatelliteSignal: ['satellite-signal', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-7.092 19.199) rotate(-45)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-1.381 5.41) rotate(-45)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.856 13.387L16.977 15.508', 'M17.379 14.410 L21.879 14.410 L21.879 21.910 L17.379 21.910 Z', 'M10.613 9.144L8.492 7.023', 'M3.590 0.621 L8.090 0.621 L8.090 8.121 L3.590 8.121 Z', 'M9.750 11.250 A3.000 3.000 0 1 0 15.750 11.250 A3.000 3.000 0 1 0 9.750 11.250 Z', 'M2.947,10.447A7.5,7.5,0,1,0,13.553,21.053', 'M5.6,13.1a3.75,3.75,0,0,0,5.3,5.3']],
  Satellite1: ['satellite-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-7.092 19.199) rotate(-45)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-1.38 5.41) rotate(-45)'
  }], ['M4.779,13.917a3.75,3.75,0,0,1,5.3,5.3Z', 'M19.7,8.542a3,3,0,0,0-.385-4.57,3.112,3.112,0,0,0-3.971.441L9.552,10.205a1.5,1.5,0,0,0,0,2.121l2.122,2.122a1.5,1.5,0,0,0,2.121,0Z', 'M21.292 2.708L19.701 4.299', 'M5.56,19.5A1.5,1.5,0,0,1,4.5,18.427', 'M8.326,22.737a5.3,5.3,0,0,1-7.055-7.078', 'M14.856 13.387L16.977 15.508', 'M17.379 14.410 L21.879 14.410 L21.879 21.910 L17.379 21.910 Z', 'M10.613 9.144L8.492 7.023', 'M3.590 0.621 L8.090 0.621 L8.090 8.121 L3.590 8.121 Z']],
  UserSignal: ['user-signal', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.375 7.875 A2.625 2.625 0 1 0 14.625 7.875 A2.625 2.625 0 1 0 9.375 7.875 Z', 'M15.75,17.25V15a3.75,3.75,0,0,0-7.5,0v2.25h1.5l.75,6h3l.75-6Z', 'M18,7.493A7.513,7.513,0,0,1,18.876,15', 'M6,7.493A7.513,7.513,0,0,0,5.124,15', 'M3,18.75a11.25,11.25,0,1,1,18,0']],
  Share: ['share', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 11.250 A3.750 3.750 0 1 0 9.000 11.250 A3.750 3.750 0 1 0 1.500 11.250 Z', 'M15.000 6.000 A3.750 3.750 0 1 0 22.500 6.000 A3.750 3.750 0 1 0 15.000 6.000 Z', 'M15.000 18.000 A3.750 3.750 0 1 0 22.500 18.000 A3.750 3.750 0 1 0 15.000 18.000 Z', 'M8.746 9.891L15.254 7.36', 'M8.605 12.928L15.395 16.323']]
};
exports["default"] = _default;